import type { FC } from "react";

import { PosTypeSearchForm } from "src/app/features/PosType/components/forms/PosTypeSearchForm";
import { PosTypesTable } from "src/app/features/PosType/components/tables/PosTypesTable";
import type { PosTypeEntity } from "src/app/features/PosType/types/PosTypeEntity";
import { PageLayout, PageTitle } from "../../../../components/AppLayout/components/Content/components";
import { NoAccessLayout } from "../../../../components/AppLayout/components/Content/components/NoAccessLayout";
import { Actions, ResourceManager } from "../../../../components/ResourceManager/ResourceManager";
import { canAccess } from "../../../../core/router/auth/permissions";
import { ResourceName } from "../../../../core/router/config/ResourceName";
import type { NoneOwnProps } from "../../../../core/types";

export const PosTypesPage: FC<NoneOwnProps> = () => {
    const table = <PosTypesTable />;
    const searchForm = <PosTypeSearchForm />;
    const hasAccess = canAccess(ResourceName.POS_TYPES, "canRead");

    return (
        <PageLayout name="PosTypes_page">
            {hasAccess ? (
                <>
                    <PageTitle translationKey="menu.posTypes" />
                    <ResourceManager<PosTypeEntity>
                        useDataGroup
                        dataMapperKey="PosTypesTableData"
                        resource={ResourceName.POS_TYPES}
                        table={table}
                        searchForm={searchForm}
                        actions={[Actions.ADD, Actions.DELETE, Actions.COPY]}
                    />
                </>
            ) : (
                <NoAccessLayout />
            )}
        </PageLayout>
    );
};
